import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import CompanyInfoForm from './blocks/CompanyInfoForm'
import EmployeeTableForm from './blocks/EmployeeTableForm'
import { OrderSalaryCardType } from 'store/types/salaryCard'
import { yupResolver } from '@hookform/resolvers/yup'
import { SalaryCardFormSchema } from '../../models/salaryCardOrder.schema'
import { useFetchOrderDetailsMutation } from 'store/reducers/salaryCards/orderDetails.api'
import OrderFormFooter from './blocks/OrderFormFooter'
import { Divider, Row } from 'antd'
import UploadEmployee from './blocks/UploadEmployee'

export default function UpdateEmployeeForm() {
  const [_, { data }] = useFetchOrderDetailsMutation({
    fixedCacheKey: 'fetchOrderDetails',
  })

  const methods = useForm<
    OrderSalaryCardType & {
      orderNo: string
      formStatus: any
      trustedPersonValid: boolean
    }
  >({
    mode: 'all',
    resolver: yupResolver(SalaryCardFormSchema()),
    values: {
      orderNo: data?.orderNo,
      cardCurrency: data?.cardCurrency,
      cardType: data?.cardType,
      orderType: data?.orderType,
      orderDeliveryType: data?.orderDeliveryType,
      orderBranch: data?.orderBranch,
      branchTransferred: data?.branchTransferred,
      note: data?.note,
      trustedPerson: data?.trustedPerson,
      tableList: !data?.employees
        ? []
        : data?.employees?.map((employee, index) => ({
            // code: employee?.secretKey,
            customerInfo: employee?.fullName,
            pin: employee?.pin,
            email: employee?.email,
            phoneNumber: employee?.phone,
            salary: employee?.salary,
            position: employee?.position,
            serialNo: employee?.serialNo,
            serialType: employee?.serialType,
            pdfTransactionId: employee?.pdfTransactionId,
            id: index,
          })),
    },
  })

  return (
    <FormProvider {...methods}>
      <Row style={{ flexDirection: 'column' }} gutter={[0, 24]}>
        <CompanyInfoForm />
        <Divider />
      </Row>
      <UploadEmployee type='update' />
      <Divider />
      <EmployeeTableForm />
      <OrderFormFooter type='update' />
    </FormProvider>
  )
}
